import { FunctionComponent } from "react";
import { useNotificationState } from "modules/notifications/hook";
import Icon from "./icon";
import {
  Message,
  NotificationContainer,
  NotificationMap,
  StyledNotification,
  Title,
  TitleContainer,
} from "./notifications.styles";

const Notifications: FunctionComponent = () => {
  const notifications = useNotificationState();
  return (
    <NotificationContainer>
      {notifications.items.map((notification) => {
        const { uuid, type, title, message } = notification;
        return (
          <StyledNotification key={uuid} type={type}>
            <TitleContainer>
              <Icon icon={NotificationMap[type].icon} />
              <Title>{title}</Title>
            </TitleContainer>
            {message && <Message>{message}</Message>}
          </StyledNotification>
        );
      })}
    </NotificationContainer>
  );
};

export default Notifications;
